import { RichTextValue, TextBox } from '@/components';
import { useTranslation } from 'react-i18next';
import { useGetArticleDetailsQuery } from '@/redux/articles';
import { ArticleStatusBadge } from '../Articles.List/ArticleStatusBadge';

interface Props {
  id: string;
}

export function ArticleDetailsPanel(props: Props) {
  const { id } = props;
  const { data } = useGetArticleDetailsQuery({ id });
  const { t } = useTranslation();

  if (!data) {
    return null;
  }

  const { title, description } = data;

  return (
    <>
      <TextBox label={t('articles.details.title')}>{title}</TextBox>
      <TextBox label={t('articles.details.status')}>
        <ArticleStatusBadge value={data} />
      </TextBox>
      <TextBox label={t('articles.details.shortDescription')}>
        {data.shortDescription}
      </TextBox>
      <RichTextValue
        label={t('articles.details.description')}
        value={description}
        ownerId={data.id}
        ownerType="Article"
      />
    </>
  );
}
